import { useEffect, useState } from "react";
import { sr } from "./sr";

// Cached region/currency so every screen shows one consistent dirham (or USD) view.
let _cache = null;
let _inflight = null;

export function refreshCurrency() {
  _cache = null;
  _inflight = null;
}

const DEFAULT = { symbol: "$", usd_to_local: 1, currency: "USD", is_live_fx: false, flag: "🇺🇸", region: "US", region_label: "United States" };

export function useCurrency() {
  const [cur, setCur] = useState(_cache || DEFAULT);
  useEffect(() => {
    let alive = true;
    if (_cache) { setCur(_cache); return; }
    if (!_inflight) {
      _inflight = sr.getRegion()
        .then((r) => { _cache = { symbol: r.symbol, usd_to_local: r.usd_to_local || 1, currency: r.currency, is_live_fx: r.is_live_fx, flag: r.flag || "🌐", region: r.region, region_label: r.region_label }; return _cache; })
        .catch(() => DEFAULT);
    }
    _inflight.then((c) => { if (alive) setCur(c); });
    return () => { alive = false; };
  }, []);

  const fx = cur.usd_to_local || 1;
  const isLocal = (cur.currency || "USD") !== "USD";
  // Format a USD amount into the client's currency.
  const money = (usd) => `${cur.symbol}${Math.round((Number(usd) || 0) * fx).toLocaleString()}`;
  const toLocal = (usd) => Math.round((Number(usd) || 0) * fx);
  const toUSD = (local) => (Number(local) || 0) / fx;
  return { ...cur, fx, isLocal, money, toLocal, toUSD };
}
